import DateCreated from './DateCreated'

export default DateCreated
